import { EditOutlined } from '@ant-design/icons';
import { Button, Descriptions, DescriptionsProps } from 'antd';
import AppDrawer from 'common/components/drawer.component';
import Loading from 'common/components/loading.component';
import TitlePage from 'common/components/title-page.component';
import { UserTranscription } from 'config/constants/transcription.constant';
import { DATE_FORMAT } from 'config/utils/globals.util';
import UserUtils from 'config/utils/user.util';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { StoreUser } from 'store/models/user.model';
import ProfileForm from '../profile-form.component';

type ProfileInfoProps = {
  user: StoreUser;
};

const ProfileInfo: React.FC<ProfileInfoProps> = ({ user: { userProfile, isFetching } }) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const items: DescriptionsProps['items'] = [
    {
      key: userProfile.name,
      label: UserTranscription.USER_NAME,
      children: userProfile.name,
    },
    {
      key: userProfile.lastName,
      label: UserTranscription.USER_LAST_NAME,
      children: userProfile.lastName,
    },
    {
      key: userProfile.phone,
      label: UserTranscription.USER_PHONE,
      children: userProfile.phone,
    },
    {
      key: userProfile.email,
      label: UserTranscription.USER_EMAIL,
      children: userProfile.email,
    },
    {
      key: `${userProfile.genre}`,
      label: UserTranscription.USER_GENRE,
      children: UserUtils.translateUserGenre(`${userProfile.genre}`),
    },
    {
      key: `${userProfile.birthDate}`,
      label: UserTranscription.USER_BIRTH_DATE,
      children: dayjs(userProfile.birthDate).format(DATE_FORMAT),
    },
    {
      key: `${userProfile.status}`,
      label: 'Estado',
      children: UserUtils.translateUserStatus(`${userProfile.status}`),
    },
  ];
  const handleOpenUserInfoDrawer = (isOpen: boolean): void => {
    setIsOpenDrawer(isOpen);
  };
  const handleActionsTitle = (): React.ReactNode => {
    return (
      <Button onClick={() => handleOpenUserInfoDrawer(true)}>
        <EditOutlined />
        {UserTranscription.EDIT_USER_INFO}
      </Button>
    );
  };
  return (
    <React.Fragment>
      <TitlePage text={UserTranscription.USER_MY_INFO} actions={handleActionsTitle()} />
      <Descriptions items={items} layout='vertical' />
      <AppDrawer title={UserTranscription.EDIT_USER_INFO} isOpen={isOpenDrawer} onClose={() => handleOpenUserInfoDrawer(false)}>
        <Loading rotate={isFetching} text={UserTranscription.SAVING_USER_INFO}>
          <ProfileForm userProfile={userProfile} callBack={handleOpenUserInfoDrawer} />
        </Loading>
      </AppDrawer>
    </React.Fragment>
  );
};
export default ProfileInfo;
